import React, { Component } from "react";
import { Growl } from "primereact/growl";
import { Messages } from "primereact/messages";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import addMonths from "date-fns/addMonths";
import subMonths from "date-fns/subMonths";
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import axios from "axios";
import { InputText } from "primereact/inputtext";
import * as appConst from "../../Common/constants";

export default class CashBalance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      banks: []
    };

    for (var i = 1; i <= 10; i++) {
      this.state[`B${i}`] = { open: 0.0, close: 0.0 };
    }

    this.onAddClick = this.onAddClick.bind(this);
  }

  componentDidMount() {
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
          
          "/bank"
      )
      .then(response => {
        this.setState({
          banks: response.data
        });
      })
      .catch(function(error) {
        console.log(error);
      });
  }

  BankDetails = () => {
    return this.state.banks.map(obj => {
      return (
        <div className="row p-1 border" key={obj.bno}>
          <div className="col col-md-4">{obj.name}</div>
          <div className="col col-md-4">
            <InputText
              type="text"
              keyfilter="money"
              value={this.state[obj.bno].open}
              onChange={e => {
                let val = e.target.value;
                this.setState(prevState => ({
                  [obj.bno]: {
                    ...prevState[obj.bno],
                    open: val
                  }
                }));
              }}
              style={{ width: "150px" }}
            />
          </div>
          <div className="col col-md-4">
            <InputText
              type="text"
              keyfilter="money"
              value={this.state[obj.bno].close}
              onChange={e => {
                let val = e.target.value;
                this.setState(prevState => ({
                  [obj.bno]: {
                    ...prevState[obj.bno],
                    close: val
                  }
                }));
              }}
              style={{ width: "150px" }}
            />
          </div>
        </div>
      );
    });
  };

  render() {
    return (
      <div>
        <h5 align="center">Cash Balance</h5>
        <div className="container-fluid">
          <div className="row p-1">
            <div className="col col-md-2 ">Select Month</div>
            <div className="col col-md-4">
              <DatePicker
                selected={this.state.month}
                onChange={e => {
                  this.setState({ month: e });
                  this.LoadData(e);
                }}
                dateFormat="MMM-yyyy"
                showMonthYearPicker
              />
            </div>
          </div>
          <div className="row p-1"></div>

          <div className="row p-1 border header">
            <div className="col col-md-4">
              <h6>Bank/Cash</h6>
            </div>
            <div className="col col-md-4">
              <h6>Opening Balance</h6>
            </div>
            <div className="col col-md-4">
              <h6>Closing Balance</h6>
            </div>
          </div>

          {this.BankDetails()}

          <div className="row p-1 border">
            <button
              onClick={this.onAddClick}
              className="btn btn-primary btn-md mr-2"
            >
              Save
            </button>
          </div>
          <Growl ref={el => (this.growl = el)} />
          <Messages ref={el => (this.messages = el)} />
        </div>
      </div>
    );
  }

  LoadData(mon) {
    const data = {
      month: mon
    };

    for (var i = 1; i <= 10; i++) {
      this.state[`B${i}`] = { open: 0.0, close: 0.0 };
    }

    axios
      .post(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
          
          "/cashBalance/load",
        data
      )
      .then(res => {
        if (res.data !== null) {
          return res.data.balance.map(obj => {
            this.setState({
              [obj.bno]: {
                open: obj.open,
                close: obj.close
              }
            });
          });
        }
      });
  }

  onAddClick = e => {
    const data = {
      month: this.state.month,
      balance: []
    };

    this.state.banks.map(obj => {
      data.balance.push({
        ...this.state[obj.bno],
        bno: obj.bno,
        bankName: obj.name
      });
    });

    axios
      .post(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
          
          "/cashBalance/save",
        data
      )
      .then(res => {
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "Cash Balance Saved !!!"
        });
      });
  };
}
